import { tv } from 'tailwind-variants'

import { StatusBadge, statusBadgeVariants } from '@/components/ui'

// Stands in for both the status and the reconcile verdict while the team checks a brokerage read.
const verifyingBadgeVariants = tv({
  extend: statusBadgeVariants,
  slots: {
    base: 'whitespace-nowrap bg-sky-50 text-sky-700 border-sky-200 hover:bg-sky-100',
    dot: 'bg-sky-500',
  },
})

interface VerifyingBadgeProps {
  className?: string
}

export const VerifyingBadge = ({ className }: VerifyingBadgeProps) => (
  <StatusBadge
    slots={verifyingBadgeVariants()}
    label="Verifying"
    className={className}
  />
)
